import { Wrapper } from 'components'

export const NoPermission = () => {
  return (
    <div className="w-full flex-1 py-12">
      <Wrapper>
        <div className="lg:pt-8">
          <h2 className="uppercase text-sm font-medium text-blue-900">
            Segurança
          </h2>
          <h1 className="pb-10 text-xxxl font-medium text-primary">
            Falta de permissões
          </h1>
          <p className="text-lg text-metal-900">
            Você não tem permissões suficientes para acessar esta página. Por
            favor, entre em contato com o administrador da sua conta para obter
            acesso.
          </p>
        </div>
      </Wrapper>
    </div>
  )
}
